import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ActivityCard } from './ActivityCard';

/**
 * SortableActivityCard - Wraps ActivityCard with dnd-kit sortable functionality
 * Provides touch-compatible drag and drop on mobile devices
 */
export const SortableActivityCard = ({
  activity,
  editPath,
  onDelete,
  t
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: activity.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`activity-item ${isDragging ? 'is-dragging' : ''}`}
      data-activity-id={activity.id}
    >
      <ActivityCard
        activity={activity}
        editPath={editPath}
        onDelete={onDelete}
        t={t}
        dragHandleProps={{ ...attributes, ...listeners }}
      />
    </div>
  );
};

export default SortableActivityCard;
